// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/account/account.proto" (package "mlmbox.client.account", syntax proto3)
// tslint:disable
import { Account_Profile_Ava_File_List } from "../../types/account.ts";
import { Account_Profile_Ava_List } from "../../types/account.ts";
import { Account_Info } from "../../types/account.ts";
import { Account_Id } from "../../types/account.ts";
import { Account_Profile } from "../../types/account.ts";
import { Account_Profile_Ava } from "../../types/account.ts";
import { Locale } from "../../types/locale.ts";
import { Locale_Id } from "../../types/locale.ts";
import { Account_Username } from "../../types/account.ts";
import { Account as Account$ } from "../../types/account.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.client.account.SetLoginRequest
 */
export interface SetLoginRequest {
    /**
     * @generated from protobuf field: string login = 1;
     */
    login: string;
}
/**
 * @generated from protobuf message mlmbox.client.account.SetProfileRequest
 */
export interface SetProfileRequest {
    /**
     * @generated from protobuf field: string first_name = 1;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 2;
     */
    lastName: string;
}
/**
 * @generated from protobuf message mlmbox.client.account.RemoteViewRequest
 */
export interface RemoteViewRequest {
    /**
     * @generated from protobuf field: string secret_code = 1;
     */
    secretCode: string;
}
/**
 * @generated from protobuf message mlmbox.client.account.RemoteVerifyRequest
 */
export interface RemoteVerifyRequest {
    /**
     * @generated from protobuf field: string secret_code = 1;
     */
    secretCode: string;
    /**
     * @generated from protobuf field: bool verified = 2;
     */
    verified: boolean;
}
/**
 * @generated from protobuf message mlmbox.client.account.RemoteViewResponse
 */
export interface RemoteViewResponse {
    /**
     * @generated from protobuf field: string user_agent = 1;
     */
    userAgent: string;
    /**
     * @generated from protobuf field: string ip_address = 2;
     */
    ipAddress: string;
    /**
     * @generated from protobuf field: uint32 expired_at = 3;
     */
    expiredAt: number;
}
/**
 * @generated from protobuf message mlmbox.client.account.RemoteVerifyResponse
 */
export interface RemoteVerifyResponse {
    /**
     * @generated from protobuf field: string user_agent = 1;
     */
    userAgent: string;
    /**
     * @generated from protobuf field: string ip_address = 2;
     */
    ipAddress: string;
    /**
     * @generated from protobuf field: bool verified = 3;
     */
    verified: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class SetLoginRequest$Type extends MessageType<SetLoginRequest> {
    constructor() {
        super("mlmbox.client.account.SetLoginRequest", [
            { no: 1, name: "login", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SetLoginRequest>): SetLoginRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.login = "";
        if (value !== undefined)
            reflectionMergePartial<SetLoginRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetLoginRequest): SetLoginRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string login */ 1:
                    message.login = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetLoginRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string login = 1; */
        if (message.login !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.login);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.account.SetLoginRequest
 */
export const SetLoginRequest = new SetLoginRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetProfileRequest$Type extends MessageType<SetProfileRequest> {
    constructor() {
        super("mlmbox.client.account.SetProfileRequest", [
            { no: 1, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SetProfileRequest>): SetProfileRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.firstName = "";
        message.lastName = "";
        if (value !== undefined)
            reflectionMergePartial<SetProfileRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetProfileRequest): SetProfileRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string first_name */ 1:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 2:
                    message.lastName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetProfileRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string first_name = 1; */
        if (message.firstName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 2; */
        if (message.lastName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.account.SetProfileRequest
 */
export const SetProfileRequest = new SetProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteViewRequest$Type extends MessageType<RemoteViewRequest> {
    constructor() {
        super("mlmbox.client.account.RemoteViewRequest", [
            { no: 1, name: "secret_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RemoteViewRequest>): RemoteViewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secretCode = "";
        if (value !== undefined)
            reflectionMergePartial<RemoteViewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteViewRequest): RemoteViewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string secret_code */ 1:
                    message.secretCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteViewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string secret_code = 1; */
        if (message.secretCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.secretCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.account.RemoteViewRequest
 */
export const RemoteViewRequest = new RemoteViewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteVerifyRequest$Type extends MessageType<RemoteVerifyRequest> {
    constructor() {
        super("mlmbox.client.account.RemoteVerifyRequest", [
            { no: 1, name: "secret_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "verified", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RemoteVerifyRequest>): RemoteVerifyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secretCode = "";
        message.verified = false;
        if (value !== undefined)
            reflectionMergePartial<RemoteVerifyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteVerifyRequest): RemoteVerifyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string secret_code */ 1:
                    message.secretCode = reader.string();
                    break;
                case /* bool verified */ 2:
                    message.verified = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteVerifyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string secret_code = 1; */
        if (message.secretCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.secretCode);
        /* bool verified = 2; */
        if (message.verified !== false)
            writer.tag(2, WireType.Varint).bool(message.verified);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.account.RemoteVerifyRequest
 */
export const RemoteVerifyRequest = new RemoteVerifyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteViewResponse$Type extends MessageType<RemoteViewResponse> {
    constructor() {
        super("mlmbox.client.account.RemoteViewResponse", [
            { no: 1, name: "user_agent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ip_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expired_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RemoteViewResponse>): RemoteViewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAgent = "";
        message.ipAddress = "";
        message.expiredAt = 0;
        if (value !== undefined)
            reflectionMergePartial<RemoteViewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteViewResponse): RemoteViewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_agent */ 1:
                    message.userAgent = reader.string();
                    break;
                case /* string ip_address */ 2:
                    message.ipAddress = reader.string();
                    break;
                case /* uint32 expired_at */ 3:
                    message.expiredAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteViewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_agent = 1; */
        if (message.userAgent !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAgent);
        /* string ip_address = 2; */
        if (message.ipAddress !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ipAddress);
        /* uint32 expired_at = 3; */
        if (message.expiredAt !== 0)
            writer.tag(3, WireType.Varint).uint32(message.expiredAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.account.RemoteViewResponse
 */
export const RemoteViewResponse = new RemoteViewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteVerifyResponse$Type extends MessageType<RemoteVerifyResponse> {
    constructor() {
        super("mlmbox.client.account.RemoteVerifyResponse", [
            { no: 1, name: "user_agent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ip_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "verified", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RemoteVerifyResponse>): RemoteVerifyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAgent = "";
        message.ipAddress = "";
        message.verified = false;
        if (value !== undefined)
            reflectionMergePartial<RemoteVerifyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteVerifyResponse): RemoteVerifyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_agent */ 1:
                    message.userAgent = reader.string();
                    break;
                case /* string ip_address */ 2:
                    message.ipAddress = reader.string();
                    break;
                case /* bool verified */ 3:
                    message.verified = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteVerifyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_agent = 1; */
        if (message.userAgent !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAgent);
        /* string ip_address = 2; */
        if (message.ipAddress !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ipAddress);
        /* bool verified = 3; */
        if (message.verified !== false)
            writer.tag(3, WireType.Varint).bool(message.verified);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.account.RemoteVerifyResponse
 */
export const RemoteVerifyResponse = new RemoteVerifyResponse$Type();
/**
 * @generated ServiceType for protobuf service mlmbox.client.account.Account
 */
export const Account = new ServiceType("mlmbox.client.account.Account", [
    { name: "Info", options: {}, I: Empty, O: Account$ },
    { name: "SetLogin", options: {}, I: SetLoginRequest, O: Account_Username },
    { name: "SetLocale", options: {}, I: Locale_Id, O: Locale },
    { name: "SetAva", options: {}, I: Account_Profile_Ava, O: Account_Profile },
    { name: "SetProfile", options: {}, I: SetProfileRequest, O: Account_Profile },
    { name: "SetReferral", options: {}, I: Account_Id, O: Account_Info },
    { name: "GetAvaFiles", options: {}, I: Account_Profile_Ava_List, O: Account_Profile_Ava_File_List },
    { name: "RemoteView", options: {}, I: RemoteViewRequest, O: RemoteViewResponse },
    { name: "RemoteVerify", options: {}, I: RemoteVerifyRequest, O: RemoteVerifyResponse }
]);
